// LIST
export const FETCH_MEDICATION = "app/MEDICATION/FETCH_MEDICATION";
export const FETCH_MEDICATION_SUCCESS =
  "app/MEDICATION/FETCH_MEDICATION_SUCCESS";
export const FETCH_MEDICATION_FAILURE =
  "app/MEDICATION/FETCH_MEDICATION_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/MEDICATION/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/MEDICATION/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/MEDICATION/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_MEDICATION = "app/MEDICATION/ADD_MEDICATION";
export const ADD_MEDICATION_SUCCESS = "app/MEDICATION/ADD_MEDICATION_SUCCESS";
export const ADD_MEDICATION_FAILURE = "app/MEDICATION/ADD_MEDICATION_FAILURE";

// EDIT
export const EDIT_MEDICATION = "app/MEDICATION/EDIT_MEDICATION";
export const EDIT_MEDICATION_SUCCESS = "app/MEDICATION/EDIT_MEDICATION_SUCCESS";
export const EDIT_MEDICATION_FAILURE = "app/MEDICATION/EDIT_MEDICATION_FAILURE";

// DELETE
export const DELETE_MEDICATION = "app/MEDICATION/DELETE_MEDICATION";
export const DELETE_MEDICATION_SUCCESS =
  "app/MEDICATION/DELETE_MEDICATION_SUCCESS";
export const DELETE_MEDICATION_FAILURE =
  "app/MEDICATION/DELETE_MEDICATION_FAILURE";
